import { render, staticRenderFns } from "./GestionStatus.vue?vue&type=template&id=15cbdfa4"
import script from "./GestionStatus.vue?vue&type=script&lang=js"
export * from "./GestionStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports